import "./App.css";

import { useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

import IntroSlide from "./components/slides/Slide-0";
import SlideFullTime from "./components/slides/Slide-1";
import SlideProfessione from "./components/slides/Slide-2";
import SlideContributi from "./components/slides/Slide-3";
import SlideImposta from "./components/slides/Slide-4";
import Scontrino from "./components/slides/Slide-5-scontrino";

import Seo from "./components/Seo";

const queryString = require("query-string");

const questionAnimation = {
  initial: {
    x: "90%",
    opacity: 0,
  },
  animate: {
    x: "0",
    opacity: 1,
  },
  exit: {
    x: "-90%",
    opacity: 0,
    transition: {
      delay: 0.2,
      duration: 0.2,
    },
  },
};

function App() {
  const urlParameters = queryString.parse(window.location.search);
  const navigate = useNavigate();

  return (
    <div className="App">
      <Seo />
      <div className=" border-red-500   bg-gray-50 dark:bg-gray-700 fixed  w-full overflow-x-hidden">
        <div className="h-full p-2 md:p-8 relative">
          <AnimatePresence mode="wait">
            <motion.div
              key={urlParameters.currentStep}
              className="h-full"
              variants={questionAnimation}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={{ type: "tween" }}
            >
              {
                {
                  undefined: (
                    <IntroSlide
                      urlParameters={urlParameters}
                      navigate={navigate}
                      queryString={queryString}
                    />
                  ),
                  1: (
                    <SlideFullTime
                      urlParameters={urlParameters}
                      navigate={navigate}
                      queryString={queryString}
                    />
                  ),
                  2: (
                    <SlideProfessione
                      urlParameters={urlParameters}
                      navigate={navigate}
                      queryString={queryString}
                    />
                  ),
                  3: (
                    <SlideContributi
                      urlParameters={urlParameters}
                      navigate={navigate}
                      queryString={queryString}
                    />
                  ),
                  4: (
                    <SlideImposta
                      urlParameters={urlParameters}
                      navigate={navigate}
                      queryString={queryString}
                    />
                  ),
                  5: <Scontrino urlParameters={urlParameters} />,
                }[urlParameters.currentStep]
              }
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}

export default App;
